import React, {Component} from 'react'

import Registry from '../../../registry/index';

class XXLFunctionsBanner extends Component {

    render() {
        let lang = Registry.get('locale');

        let { browser } = this.props;

        return (
            <div className="functions-xxl">
                <a
                    className="functions-xxl-link"
                    href={browser.desktop ? lang.path + '/bobtv-xxl' : '#'}
                    target={browser.desktop ? '_blank' : '_self'}
                    dangerouslySetInnerHTML={{__html:lang.functions_xxl_link}}
                    ref={(link) => this.link = link}
                />
                <div
                    className="popup-functions-xxl"
                    dangerouslySetInnerHTML={{__html:lang.functions_xxl_text}}
                    ref={(ref) => this._ref = ref}
                />
            </div>
        )
    }
}

export default XXLFunctionsBanner;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/XXLFunctionsBanner/index.js